// Configuration for EmailJS service

// These are the actual EmailJS credentials used for sending emails from the contact form
// You should update these with valid credentials from your EmailJS account or environment variables
export const EMAILJS_CONFIG = {
  // The EmailJS service ID (e.g., 'service_xxxxx')
  SERVICE_ID: import.meta.env.VITE_EMAILJS_SERVICE_ID || "service_2dr8ujf",
  // The EmailJS template ID (e.g., 'template_xxxxx')
  TEMPLATE_ID: import.meta.env.VITE_EMAILJS_TEMPLATE_ID || "template_7htswih",
  // The EmailJS public key (e.g., 'user_xxxxx')
  PUBLIC_KEY: import.meta.env.VITE_EMAILJS_PUBLIC_KEY || "-OCi7Vie1RCIEMiyG",
  // The default recipient email address for contact form submissions
  DEFAULT_TO_EMAIL: "martin@stratodata.eu"
};

/**
 * EmailJS Setup Instructions:
 * 
 * 1. Create an account at https://www.emailjs.com/
 * 2. Create a new Email Service (e.g. Gmail, Outlook, etc.)
 * 3. Create a new Email Template with the following template variables:
 *    - from_name: Sender's name
 *    - from_email: Sender's email
 *    - from_company: Sender's company
 *    - message: Message content
 *    - service_type: Type of service inquired about
 *    - to_email: Recipient email (optional, can be hardcoded in the template)
 * 
 * 4. Get your Service ID, Template ID, and Public Key from EmailJS dashboard
 *    Important: Verify that the template exists in your EmailJS account.
 *    If you see "The template ID not found" error, check your EmailJS dashboard
 *    and update the TEMPLATE_ID value above with a valid template ID.
 * 
 * 5. For local development:
 *    Create a .env.local file in the root of your project with:
 *    VITE_EMAILJS_SERVICE_ID=your_service_id
 *    VITE_EMAILJS_TEMPLATE_ID=your_template_id
 *    VITE_EMAILJS_PUBLIC_KEY=your_public_key
 * 
 * 6. For production:
 *    Set these environment variables in your hosting environment
 */
